module.exports = __webpack_public_path__ + "img/clean.c9c991e5.svg";